import React from "react";
import { Route, Routes } from "react-router-dom";
import { TenantConfigPage } from "./containers";

export const TenantConfig = () => {
  return (
    <Routes>
      <Route path="/" element={<TenantConfigPage />} />
    </Routes>
  );
};